export const baseURL = "https://api.fxbroker.dev-iuh.xyz/";
